import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaTelegram,
  FaInstagram,
  FaLinkedin,
  FaGithub,
} from "react-icons/fa";

const FooterContainer = styled.footer`
  background-color: #262626;
  color: #fff;
  text-align: center;
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const Logo = styled.img`
  max-width: 200px;
  height: auto;
  margin-bottom: 10px;
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  &:hover {
    color: #cc0000;
  }
  a {
    &:hover {
      color: #cc0000;
    }
  }
`;

const IconWrapper = styled.span`
  color: #cc0000;
  font-size: 21px;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
`;

const ATag = styled.a`
  color: white;
  text-decoration: none;
`;

const SocialIconLink = styled.a`
  color: #fff;
  font-size: 28px;
  transition: color 0.3s;

  &:hover {
    color: #cc0000;
  }
`;

const Footer = () => {
  const [orientation, setOrientation] = useState('portrait');
  useEffect(() => {
    const handleResize = () => {
      setOrientation(window.innerWidth > window.innerHeight ? 'landscape' : 'portrait');
    };

    handleResize(); // Check initial orientation
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <FooterContainer style={orientation == "portrait" ? { width: "100%", height: "100vh", overflow: "hidden" } : {}}>
      <FooterContent>
        <Logo
          src={orientation == "landscape" ? "full_white_landscape.png" : "full_white_portrait.png"}
          alt="Company Logo"
          style={orientation == "portrait" ? { marginTop: "25%" } : { marginTop: "60px" }}
        />
        <a referrerpolicy={'origin'} target={'_blank'}
          href={'https://trustseal.enamad.ir/?id=586674&Code=MYjTPsm8jAjgS5IhG6habxYoONXZqDkE'}>
          <img
            referrerpolicy={'origin'}
            src={'https://trustseal.enamad.ir/logo.aspx?id=586674&Code=MYjTPsm8jAjgS5IhG6habxYoONXZqDkE'}
            alt={''} style={{ cursor: 'pointer' }} code={'MYjTPsm8jAjgS5IhG6habxYoONXZqDkE'} />

        </a>
        <ContactInfo style={orientation == "portrait" ? { marginTop: "10%" } : { marginTop: "40px" }}>
          <ContactItem>
            {/* <IconWrapper>
              <FaMapMarkerAlt />
            </IconWrapper> */}
            <span>تهران، خیابان آزادی، روبروی خیابان دکتر قریب، پلاک 134</span>
          </ContactItem>
          <ContactItem>
            {/* <IconWrapper>
              <FaPhoneAlt />
            </IconWrapper> */}
            <ATag style={{ direction: 'ltr' }} href="tel:+989981757726">+989981757726</ATag>
          </ContactItem>
          <ContactItem>
            {/* <IconWrapper>
              <FaEnvelope />
            </IconWrapper> */}
            <ATag href="mailto:info@kajdom.com">info@kajdom.com</ATag>
          </ContactItem>
        </ContactInfo>
        <SocialIcons>
          <SocialIconLink
            href="https://telegram.org"
            target="_blank"
            aria-label="Telegram"
          >
            <FaTelegram />
          </SocialIconLink>
          <SocialIconLink
            href="https://instagram.com"
            target="_blank"
            aria-label="Instagram"
          >
            <FaInstagram />
          </SocialIconLink>
          <SocialIconLink
            href="https://linkedin.com"
            target="_blank"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </SocialIconLink>
          <SocialIconLink
            href="https://github.com"
            target="_blank"
            aria-label="GitHub"
          >
            <FaGithub />
          </SocialIconLink>
        </SocialIcons>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
